import { useEffect, useState } from "react";
import { handleInput, showMessageError } from "../../../../classes/functions";
import api from "../../../../config";
import { parametersTypes } from "../../../../classes/consts";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function Inputs({infos}){
    const {option, id} = useParams();
    const [parameters, setParameters] = useState([]);
    const [typeOfValueInput, setTypeOfValueInput] = useState("text");

    function getParameters(){
        const filterByCompaniesDifferentsOfCurrent = `!empresa=${localStorage.getItem("empresa")}`;
        
        api
        .get(`/api/parametros?${!id ? filterByCompaniesDifferentsOfCurrent : ""}`)
        .then((response) => {
            let adaptedValuesToSelectLib = [];

            response.data.result.map((parameter) => {
                adaptedValuesToSelectLib.push({label: parameter.nome, value: parameter.id, tipo: parameter.tipo, descricao: parameter.descricao});
            });

            setParameters(adaptedValuesToSelectLib);
        })
        .catch((error) => {
            console.log(error);

            if(error?.response?.data){
                showMessageError(error?.response?.data);
            }
        });
    }

    function changeTypeOfInputValue(){
        const selectedParameter = parameters.filter((parameter) => parameter.value === parseInt(infos?.state?.parametro))[0];
        const typeInParametersTypeList = parametersTypes.filter((parameterType) => parameterType.value === selectedParameter?.tipo)[0]?.inputType;

        setTypeOfValueInput(typeInParametersTypeList);
    }

    useEffect(() => {
        getParameters();
    }, []);

    useEffect(() => {
        if(infos?.state?.parametro){
            changeTypeOfInputValue();
        }
    }, [infos?.state?.parametro]);

    return (
        <div className="divGroup" style={{display: "flex", alignItems: "center"}}>
            <div className="formDiv" style={{width: "20%"}}>
                <label>Parâmetro</label>
                <select value={infos.state.parametro} name="parametro" onChange={(event) => handleInput(infos.setState, event)}>
                    <option value="">Selecione</option>
                    {parameters.map((parameter, index) => {
                        return (
                            <option value={parameter.value} key={index}>{parameter.label}</option>
                        )
                    })}
                </select>
            </div>
            <div className="formDiv" style={{width: "20%"}}>
                <label>Valor</label>&nbsp;<label className="required">*</label><br />
                {typeOfValueInput === "boolean"
                    ? 
                        <select name="valor" value={infos?.state?.valor} onChange={(event) => handleInput(infos.setState, event, "boolean")}>
                            <option value="">Selecione</option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    : 
                        <input type={typeOfValueInput} name="valor" placeholder="Valor" value={infos.state.valor} onChange={(event) => handleInput(infos.setState, event)} />
                }
            </div>
            <div className="formDiv" style={{width: "20%"}}>
                <label>Ativo</label>&nbsp;<label className="required">*</label><br />
                <select value={infos.state.ativo} name="ativo" onChange={(event) => handleInput(infos.setState, event)}>
                    <option value="">Selecione</option>
                    <option value="Sim">Sim</option>
                    <option value="Não">Não</option>
                </select>
            </div>
            <div className="formDiv" style={{width: "40%"}}>
                <label>Descrição</label>
                <input value={parameters.filter((parameter) => parameter.value === parseInt(infos.state.parametro))[0]?.descricao} name="descricao" onChange={(event) => handleInput(infos.setState, event)} placeholder="Descrição" disabled={true} />
            </div>
        </div>
    )
}